import { useGetGeneralPurchasePolicyQuery } from '@account-root/procurement-react/src/generated/graphql'
import { yupResolver } from '@hookform/resolvers'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { ItemVoiceTextField } from '@ifca-root/react-component/src/components/Input/CustomItemTextField'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { PaginatedAutocomplete } from '@ifca-root/react-component/src/containers/ComponentModule/PaginatedAutoComplete'
import {
  CircularProgress,
  Grid,
  ListItemText,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core'
import { Autocomplete, createFilterOptions } from '@material-ui/lab'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import {
  CommonStatus,
  useGetClassificationCodeLazyQuery,
  useGetDepartmentListingByItemIdLazyQuery,
  useGetDocumentDateValidationQuery,
  useGetTaxSchemeNewListingQuery,
  useGetUomExchangeListLazyQuery,
  useGetGlCompanyPolicyQuery,
  useGetTaxExemptionCalculationLazyQuery,
} from 'generated/graphql'
import { calculateTaxDetail } from 'helpers/Calculation/taxCalculationDetail'
import { filterTaxSchemeEffectiveDate } from 'helpers/Filter/filterTaxSchemeEffectiveDate'
import { CommonYupValidation } from 'helpers/Form/YupValidation'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { amtNumStr, amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { Fragment, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import * as yup from 'yup'
import {
  baseAmount,
  getTotalAmtWithQty,
} from '../../ARAPModule/Helper/AmountCalculation'
import { DefaultDepartmentHandlerService } from 'containers/GeneralLedgerModule/Hooks/DefaultDepartment/DefaultDepartmentService'

export interface TaxExemptionCalculationData {
  TaxExemptionRate: number | null
  TaxExemptionAmount: number | null
}

interface ItemProps {
  Quantity: number
  ExpenseItemID: string
  UOMID: string
  Amount: number
  UnitPrice: number
  DocAmt: number
  TaxSchemeID: string
  TaxAmt: any
  TaxAmtDetail: any
  TaxRate: number
  CostCentreID: string
  SalesOrderID: string
  DebtorAccountID: string
  Remark: string
  einvoice_classification_code_id: string
  TaxExemptionReason: string
  TaxExemptionAmount: number
  TaxExemptionRate: number
}

const defaultVal: any = {
  ExpenseItemID: '',
  Amount: 0,
  DocAmt: 0,
  UnitPrice: 0,
  TaxSchemeID: '',
  TaxAmt: 0,
  TaxRate: 0,
  CostCentreID: '',
  SalesOrderID: '',
  DebtorAccountID: '',
  Remark: '',
  UOMID: '',
  Quantity: 0,
  einvoice_classification_code_id: '',
  TaxExemptionReason: '',
  TaxExemptionAmount: 0,
  TaxExemptionRate: 0,
}

export const ItemDialog = (props: any) => {
  const {
    companyID,
    getDebtorAccount,
    DebtorAccountLoading,
    editData,
    fetchSalesOrder,
    openItemDialog,
    setOpenItemDialog,
    itemData,
    ExpenseItemLoading,
    getItemByCompany,
    title,
    detailMode,
    menu,
    selectedTax,
    setSelectedTax,
    primaryItemKey,
    fetchExpenseItem,
    totalLength,
    setOptions,
    selfBillStatus,
    EInvoiceStarted,
    creditorAcc,
    localData,
    getSalesOrderByDebtor,
    SalesOrderLoading,
    docType,
  } = props

  const [showExemptedFields, setShowExemptedFields] = useState<boolean>(
    !!menu?.obj?.TaxExemptionReason
  )

  const ItemSchema = yup.object().shape({
    ExpenseItemID: CommonYupValidation.requireField('Item is required'),
    TaxSchemeID: CommonYupValidation.requireField('Tax Code is required'),
    UOMID: yup.string().required(SystemMsgs.uom()),
    CostCentreID: yup.string().nullable().required('Department is required'),
    Quantity: yup
      .number()
      .transform((originalValue, originalObject) => {
        if (originalValue?.length > 3) {
          return parseInt(originalObject.replace(/,/g, ''))
        } else {
          return parseFloat(originalObject)
        }
      })
      .min(0.01, 'Quantity must be at least 0.01')
      .required('Quantity must be at least 0.01'),
    UnitPrice: yup
      .number()
      .transform((originalValue, originalObject) => {
        if (originalValue?.length > 3) {
          return parseInt(originalObject.replace(/,/g, ''))
        } else {
          return parseFloat(originalObject)
        }
      })
      .min(0.0001, 'Quantity must be at least 0.0001')
      .required('Unit Price is required'),
    Remark: CommonYupValidation.requireField('Remark is required'),
    ...(!!selfBillStatus && EInvoiceStarted
      ? {
          einvoice_classification_code_id: CommonYupValidation.requireField(
            SystemMsgs.ClassificationCode()
          ),
        }
      : null),
    ...(!!showExemptedFields
      ? {
          TaxExemptionReason: CommonYupValidation.requireField(
            SystemMsgs.taxExemptionReason()
          ),
        }
      : null),
  })
  const {
    handleSubmit: handleItemSubmit,
    register: itemRegister,
    setValue: setValueItem,
    watch: itemWatch,
    errors: itemErrors,
    control: itemControl,
    clearErrors: clearErrorsItem,
    getValues: getValuesItem,
    reset: itemReset,
  } = useForm<ItemProps>({
    defaultValues: {
      ExpenseItemID: !!menu ? menu?.obj?.ExpenseItemID : '',
      Amount: !!menu ? menu?.obj?.Amount : 0,
      UnitPrice: !!menu ? menu?.obj?.UnitPrice : 0,
      CostCentreID: !!menu ? menu?.obj?.CostCentreID : '',
      SalesOrderID: !!menu ? menu?.obj?.SalesOrderID : '',
      DebtorAccountID: !!menu ? menu?.obj?.DebtorAccountID : '',
      DocAmt: !!menu ? menu?.obj?.DocAmt : 0,
      TaxSchemeID: !!menu ? menu?.obj?.TaxSchemeID : '',
      TaxAmt: 0,
      TaxRate: 0,
      TaxAmtDetail: [],
      Remark: !!menu ? menu?.obj?.Remark : '',
      TaxExemptionReason: !!menu?.obj?.TaxExemptionReason
        ? menu?.obj?.TaxExemptionReason
        : '',
      einvoice_classification_code_id: !!menu
        ? menu?.obj?.einvoice_classification_code_id
        : '',
    },
    mode: 'onSubmit',
    resolver: yupResolver(ItemSchema),
  })

  const itemEditData =
    !!menu && menu?.obj?.ExpenseItemID
      ? getItemByCompany?.filter(
          item => item?.ExpenseItemID === menu?.obj?.ExpenseItemID
        )[0]
      : null

  const [unitPrice, setUnitPrice] = useState<any>(
    detailMode === 'edit' ? menu?.obj?.UnitPrice : 0
  )

  const [qty, setQty] = useState(
    detailMode === 'edit' ? menu?.obj?.Quantity : 0
  )

  const [uomID, setUomID] = useState('')

  const [refresh, setRefresh] = useState(!!menu?.obj?.ExpenseItemID)
  const [isSaveNewClicked, setIsSaveNewClicked] = useState(false)

  const [taxAmt, setTaxAmt] = useState(
    detailMode === 'edit' ? menu?.obj?.TaxAmt : 0
  )

  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')

  const [itemRecord, setItemRecord] = useState(false)
  const [itemVoiceRemark, setItemVoiceRemark] = useState('')

  const [exemptionVoiceReason, setExemptionVoiceReason] = useState('')
  const [exemptionRecord, setExemptionRecord] = useState(false)

  const [mountDefVal, setMountDefVal] = useState(!!menu?.obj)
  const [useDefaultDept, setUseDefaultDept] = useState(false)

  const [itemColor, setItemColor] = useState(
    getItemByCompany?.find(
      item => item?.ExpenseItemID === menu?.obj?.ExpenseItemID
    )?.IsInventory === true
      ? 'darkblue'
      : ''
  )
  let date = localData?.DocDate

  useEffect(() => {
    getItemByCompany?.find(
      item => item?.ExpenseItemID === menu?.obj?.ExpenseItemID
    )?.IsInventory === true && setItemColor('darkblue')
  }, [getItemByCompany])

  const [classificationCodeID, setClassificationCodeID] = useState(
    !!menu ? menu?.obj?.einvoice_classification_code_id : null
  )
  const user = JSON.parse(localStorage.getItem('loggedInUser'))

  // e-Invoice Query
  const [
    loadClassificationCode,
    {
      loading: ClassificationCodeLoading,
      data: { getClassificationCode } = { getClassificationCode: [] },
    },
  ] = useGetClassificationCodeLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: data => {
      if (!!classificationCodeID) {
        itemRegister('einvoice_classification_code_id')
        setValueItem(
          'einvoice_classification_code_id',
          data.getClassificationCode.filter(
            x => x?.id === classificationCodeID
          )[0].id
        )
      }
    },
  })

  const { loading: GLCompanyLoading } = useGetGlCompanyPolicyQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: companyID },
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setValueItem('UOMID', null)
    },
    onCompleted: ({ getGLCompanyPolicy }) => {
      setUseDefaultDept(getGLCompanyPolicy[0]?.DefaultDepartmentBalanceSheetCOA)
    },
  })

  const {
    loading: GPPolicyLoading,
    data: { getGeneralPurchasePolicy } = { getGeneralPurchasePolicy: [] },
  } = useGetGeneralPurchasePolicyQuery({
    fetchPolicy: 'network-only',
    variables: { AccountID: user?.accountID },
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setValueItem('UOMID', null)
    },
  })

  const classificationCode = !!classificationCodeID
    ? getClassificationCode?.filter(x => x?.id === classificationCodeID)[0]
        ?.classificationCode
    : getClassificationCode?.filter(
        x => x?.id === menu?.obj?.einvoice_classification_code_id
      )[0]?.classificationCode

  const classificationDescription = !!classificationCodeID
    ? getClassificationCode?.filter(x => x?.id === classificationCodeID)[0]
        ?.description
    : getClassificationCode?.filter(
        x => x?.id === menu?.obj?.einvoice_classification_code_id
      )[0]?.description

  const {
    loading: TaxSchemeListingLoading,
    data: { getTaxSchemeListing: getTaxScheme } = { getTaxSchemeListing: [] },
  } = useGetTaxSchemeNewListingQuery({
    fetchPolicy: 'network-only',
    variables: { CommonStatus: CommonStatus.Active, TaxClass: ['INPUT'] },
    onCompleted: () => {
      if (detailMode === 'edit') {
        let selectTax = taxSchemeInput?.find(
          x => x?.id === menu?.obj?.TaxSchemeID
        )
        setSelectedTax(selectTax)

        initializeTaxDetailsInEditMode(selectTax)

        if (menu?.obj?.UnitPrice) {
          setUnitPrice(menu.obj.UnitPrice)
          setValueItem('UnitPrice', menu.obj.UnitPrice)
        }
        if (menu?.obj?.Quantity) {
          setQty(menu.obj.Quantity)
          setValueItem('Quantity', menu.obj.Quantity)
        }
        if (selfBillStatus && itemEditData) {
          loadClassificationCode()
          itemRegister('einvoice_classification_code_id')
          setClassificationCodeID(menu?.obj?.einvoice_classification_code_id)
        }

        loadClassificationCode()
      }
    },
  })

  const [
    fetchUOM,
    {
      loading: uomExcLoading,
      data: { getUOMExchangeList } = { getUOMExchangeList: [] },
    },
  ] = useGetUomExchangeListLazyQuery({
    fetchPolicy: 'network-only',
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setValueItem('UOMID', null)
    },
    onCompleted: data => {
      if (!!uomID) {
        itemRegister('UOMID')
        setValueItem(
          'UOMID',
          data.getUOMExchangeList.filter(x => x?.uomid === uomID)[0].uomid
        )
      }
    },
  })

  /* -------------------------------------------- */
  /*                   DEF DEPT                   */
  /* -------------------------------------------- */
  const [
    fetchDepartmentListingByItemID,
    {
      loading: HandlerLoading,
      called: HandlerCalled,
      data: { getDepartmentListingByItemID } = {
        getDepartmentListingByItemID: [],
      },
    },
  ] = useGetDepartmentListingByItemIdLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: ({ getDepartmentListingByItemID }) => {
      if (menu?.obj?.CostCentreID || itemWatch('CostCentreID') === '') {
        DefaultDepartmentHandlerService.InitializeDepartmentValueInEditMode({
          DepartmentListingArray: getDepartmentListingByItemID,
          DefaultDepartmentPolicy: useDefaultDept, // nullable; used for GL Department Policy checking
          EditData: itemEditData,
          SetValue: setValueItem,
          Register: itemRegister,
          MountDefVal: mountDefVal, // to avoid overriding costcentreid on another api call
        })
      } else {
        if (
          getDepartmentListingByItemID?.length === 1 &&
          getDepartmentListingByItemID[0]?.IsDefault === true
        ) {
          itemRegister('CostCentreID')
          setValueItem(
            'CostCentreID',
            getDepartmentListingByItemID[0].CostCentreID
          )
        }
      }
    },
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(`${errorMessage}"`)
    },
  })

  const isDefaultChecking: boolean =
    HandlerCalled === true
      ? !!(
          getDepartmentListingByItemID?.length === 1 &&
          !!getDepartmentListingByItemID[0]?.IsDefault
        )
      : false

  const disableDeptController: boolean = !!(
    useDefaultDept === true && isDefaultChecking === true
  )
  //============================================================================

  /* -------------------------------------------- */
  /*                 EXEMPTED TAX                 */
  /* -------------------------------------------- */
  const [awaitCalc, setAwaitCalc] = useState<boolean>(false)
  const [debounceTimer, setDebounceTimer] = useState(null)
  const [taxExemptionData, setTaxExemptionData] =
    useState<TaxExemptionCalculationData>({
      TaxExemptionRate: menu?.obj?.TaxExemptionRate ?? null,
      TaxExemptionAmount: menu?.obj?.TaxExemptionAmount ?? null,
    })

  const [fetchExemptedTaxCalc, { loading: ExemptedTaxCalcLoading }] =
    useGetTaxExemptionCalculationLazyQuery({
      fetchPolicy: 'network-only',
      onError: error => {
        let errorMessage = error.message.substring(15)
        console.log('ERROR', error)
        setErrorDia(true)
        setErrMsg(`${errorMessage}"`)

        setAwaitCalc(false)
      },
      onCompleted: ({ getTaxExemptionCalculation }) => {
        setTaxExemptionData({
          TaxExemptionRate: getTaxExemptionCalculation?.TaxExemptionRate,
          TaxExemptionAmount: getTaxExemptionCalculation?.TaxExemptionAmount,
        })

        setAwaitCalc(false)
      },
    })

  // Debounce method for API based calculation
  const debounceExemptCalc = (
    currTaxSchemeId: string,
    effDate: Date,
    baseAmt: number
  ) => {
    setAwaitCalc(true)
    setTaxExemptionData({ TaxExemptionAmount: null, TaxExemptionRate: null })
    if (debounceTimer) {
      clearTimeout(debounceTimer)
    }

    const newTimer = setTimeout(() => {
      fetchExemptedTaxCalc({
        variables: {
          TaxSchemeID: currTaxSchemeId,
          EffectiveDate: effDate,
          BaseAmount: baseAmt,
        },
      })
    }, 1500)

    setDebounceTimer(newTimer)
  }

  //============================================================================

  const {
    loading: DocDateValidationLoading,
    data: { getDocumentDateValidation } = { getDocumentDateValidation: [] },
  } = useGetDocumentDateValidationQuery({ fetchPolicy: 'network-only' })

  const taxCodeName = getTaxScheme?.filter(x => x?.id === selectedTax?.id)[0]
    ?.name

  const costCentreCode =
    itemWatch('CostCentreID') !== undefined
      ? getDepartmentListingByItemID.filter(
          x => x?.CostCentreID === itemWatch('CostCentreID')
        )[0]?.Code
      : getDepartmentListingByItemID.filter(
          x => x?.CostCentreID === menu?.obj?.CostCentreID
        )[0]?.Code

  const itemName =
    itemWatch('ExpenseItemID') !== undefined
      ? getItemByCompany?.filter(
          x => x?.ExpenseItemID === itemWatch('ExpenseItemID')
        )[0]?.ItemName
      : getItemByCompany?.filter(
          x => x?.ExpenseItemID === menu?.obj?.ExpenseItemID
        )[0]?.ItemName

  const onSubmit = (data, docAmt, qty, unitPrice, amount, index, isSaveNew) => {
    const formattedTaxDetails = result.taxDetails.map((tax, idx) => {
      const calculatedTaxAmt =
        Number(itemWatch(`TaxAmtDetail[${idx}]`)) ?? tax.TaxAmount
      const finalTaxAmt =
        tax.schemeTypeCode === 'WHT'
          ? -Math.abs(calculatedTaxAmt)
          : calculatedTaxAmt

      return {
        seqNo: tax?.SeqNo,
        taxAmt: finalTaxAmt,
        taxRate: tax.TaxRate * 100,
        taxCode: tax.taxCode,
        taxId: tax.taxId,
        taxSchemeDetailId: tax.taxSchemeDetailId,
        taxSchemeId: tax.taxSchemeId,
      }
    })

    if (detailMode === 'add') {
      itemData.push({
        Sequence: itemData?.length + 1,
        ExpenseItemID: data?.ExpenseItemID,
        CostCentreID: data?.CostCentreID,
        UnitPrice: unitPrice,
        Amount: docAmt - parseFloat(taxAmt),
        Quantity: qty,
        UOMID: uomID,
        TaxSchemeID: data?.TaxSchemeID,
        TaxCode: taxCodeName,
        TaxRate: 0,
        ExpenseItemName: itemName,
        CostCentreCode: costCentreCode,
        TaxAmt: parseFloat(taxAmt),
        DocAmt: docAmt,
        Remark: data?.Remark,
        SalesOrderID: data?.SalesOrderID || null,
        DebtorAccountID: data?.DebtorAccountID || null,
        ItemTaxInfo: formattedTaxDetails,
        einvoice_classification_code_id:
          !!selfBillStatus && EInvoiceStarted ? classificationCodeID : null,
        ClassificationCode:
          !!selfBillStatus && EInvoiceStarted ? classificationCode : null,
        ClassificationDescription:
          !!selfBillStatus && EInvoiceStarted
            ? classificationDescription
            : null,
        TaxExemptionReason:
          showExemptedFields && data?.TaxExemptionReason
            ? data?.TaxExemptionReason
            : null,
        TaxExemptionAmount:
          showExemptedFields && taxExemptionData?.TaxExemptionAmount
            ? taxExemptionData?.TaxExemptionAmount
            : null,
        TaxExemptionRate:
          showExemptedFields && taxExemptionData?.TaxExemptionRate
            ? taxExemptionData?.TaxExemptionRate
            : null,
      })
    } else {
      let existingItemData = itemData[index]

      itemData[index] = {
        Sequence: itemData?.Sequence ?? index + 1,
        [`${primaryItemKey}`]: itemData[index]?.[`${primaryItemKey}`],
        ...(!!menu?.obj?.DOItemID
          ? { DOItemID: menu?.obj?.DOItemID }
          : !!menu?.obj?.GRTNItemID
            ? { GRTNItemID: menu?.obj?.GRTNItemID }
            : null),
        ExpenseItemID: data?.ExpenseItemID,
        CostCentreID: data?.CostCentreID,
        UnitPrice: unitPrice,
        Amount: docAmt - parseFloat(taxAmt ?? existingItemData?.TaxAmt),
        ExpenseItemName: itemName,
        CostCentreCode: costCentreCode,
        Quantity: qty,
        UOMID: uomID,
        TaxRate: 0,
        TaxCode: taxCodeName,
        TaxSchemeID: data?.TaxSchemeID,
        TaxAmt: parseFloat(taxAmt),
        DocAmt: docAmt,
        Remark: data?.Remark,
        SalesOrderID: data?.SalesOrderID || null,
        DebtorAccountID: data?.DebtorAccountID || null,
        ItemTaxInfo: formattedTaxDetails,
        einvoice_classification_code_id:
          !!selfBillStatus && EInvoiceStarted
            ? data?.einvoice_classification_code_id
            : null,
        ClassificationCode:
          !!selfBillStatus && EInvoiceStarted ? classificationCode : null,
        ClassificationDescription:
          !!selfBillStatus && EInvoiceStarted
            ? classificationDescription
            : null,
        TaxExemptionReason:
          showExemptedFields && data?.TaxExemptionReason
            ? data?.TaxExemptionReason
            : null,
        TaxExemptionAmount:
          showExemptedFields && taxExemptionData?.TaxExemptionAmount
            ? taxExemptionData?.TaxExemptionAmount
            : null,
        TaxExemptionRate:
          showExemptedFields && taxExemptionData?.TaxExemptionRate
            ? taxExemptionData?.TaxExemptionRate
            : null,
      }
    }
    setOptions([])
    if (!isSaveNew) {
      fetchDepartmentListingByItemID({
        variables: { CompanyID: companyID, ExpenseItemID: null },
      })
      setOpenItemDialog(false)
    } else {
      fetchDepartmentListingByItemID({
        variables: { CompanyID: companyID, ExpenseItemID: null },
      })
      setValueItem('ExpenseItemID', null)
      setRefresh(true)
      setIsSaveNewClicked(true)
      itemReset(defaultVal)
      fetchExpenseItem()
    }
    fetchExpenseItem()

    // reset tax calculation
    result = {
      taxDetails: [],
      ExcludeTaxAmount: 0,
      IncludeTaxAmount: 0,
      TaxAmount: 0,
    }
    setSelectedTax(null)
    setTaxAmt(0)
  }

  const closeFooterOption = {
    displayText: 'Close',
    props: {
      onClick: () => {
        setOptions([])
        setOpenItemDialog(false)
      },
      variant: 'contained',
      color: 'primary',
    },
  }

  const readOnly = () => {
    if (menu?.obj?.DOItemID || menu?.obj?.GRTNItemID) return true
    else return false
  }

  // ======== Functions for Expense Item ========= //
  const handleExpenseItemChange = ExpenseItemID => {
    setValueItem('ExpenseItemID', ExpenseItemID)
    // this is to get tax after select the expense item
    let defTax = getItemByCompany?.filter(
      x => x?.ExpenseItemID === ExpenseItemID
    )[0]?.TaxSchemeID

    const uom = getItemByCompany?.find(
      x => x?.ExpenseItemID === ExpenseItemID
    )?.UOMID
    setUomID(uom)

    fetchUOM({ variables: { UOMID: uom } })
    let newSelectedTax = taxSchemeInput?.find(x => x?.id === defTax)

    setValueItem('TaxSchemeID', defTax)
    setSelectedTax(newSelectedTax)
    clearErrorsItem('ExpenseItemID')

    const currentAmount = baseAmount(Number(qty), Number(unitPrice))
    const newResult = calculateTaxFromState(newSelectedTax, currentAmount)
    updateTaxDetailsInForm(newResult?.taxDetails, newResult?.TaxAmount)

    if (newSelectedTax?.isExemptedTaxScheme === true) {
      setShowExemptedFields(true)
      fetchExemptedTaxCalc({
        variables: {
          TaxSchemeID: defTax,
          EffectiveDate: new Date(localData?.DocDate),
          BaseAmount: currentAmount,
        },
      })
    }

    let ccID = creditorAcc[0]?.einvoice_classification_code_id

    if (selfBillStatus && EInvoiceStarted) {
      loadClassificationCode()
      itemRegister('einvoice_classification_code_id')
      setClassificationCodeID(ccID)
      setValueItem('einvoice_classification_code_id', ccID)
    }
  }

  useEffect(() => {
    if (!!menu?.obj?.UOMID) {
      setUomID(menu?.obj?.UOMID)
      itemRegister('UOMID')
      fetchUOM({ variables: { UOMID: uomID ?? menu?.obj?.UOMID } })
    }
  }, [uomID])

  useEffect(() => {
    if (!!menu?.obj?.SalesOrderID) {
      itemRegister('SalesOrderID')
      setValueItem('SalesOrderID', menu?.obj?.SalesOrderID)
      fetchSalesOrder({
        variables: {
          DebtorAccountID: menu?.obj?.DebtorAccountID,
          excludeSalesOrderID: menu?.obj?.SalesOrderID,
        },
      })
    }
  }, [menu?.obj])

  //UseEffect for ReadOnly
  useEffect(() => {
    if (menu?.obj?.ExpenseItemID) {
      fetchDepartmentListingByItemID({
        variables: {
          CompanyID: companyID,
          ExpenseItemID: menu?.obj?.ExpenseItemID,
        },
      })
    }
  }, [menu?.obj])

  useEffect(() => {
    if (isSaveNewClicked) {
      setRefresh(false)
      setIsSaveNewClicked(false)
    }
  }, [isSaveNewClicked])

  // ✥✥✥✥✥✥✥✥✥✥✥✥✥✥ - TAX CALCULATION - ✥✥✥✥✥✥✥✥✥✥✥✥✥✥ //
  const prepareTaxCalculationData = (selectedTax: any) => {
    if (!selectedTax?.taxSchemeDetailList[0]?.taxSchemeDetailItemList?.length) {
      return []
    }

    const taxSchemeDetail = selectedTax?.taxSchemeDetailList?.[0]

    return taxSchemeDetail.taxSchemeDetailItemList.map(item => ({
      taxId: item.taxId,
      taxSchemeId: taxSchemeDetail.taxSchemeId,
      taxSchemeDetailId: taxSchemeDetail.id,
      seqNo: item.seqNo,
      taxOnSeq: item.taxOnSeq || [],
      computeMethod:
        item.computeMethod === 'TAX_ON_GROSS'
          ? 'Tax_On_Gross'
          : 'Tax_On_Taxed_Price',
      taxRate: item.taxRate,
      taxCode: item.taxInfo?.code,
      schemeTypeCode: item.taxInfo?.schemeTypeCode,
    }))
  }

  const calculateTaxFromState = (selectedTax: any, amount: number) => {
    const taxData = prepareTaxCalculationData(selectedTax)
    const isExclusive = Boolean(selectedTax?.isExclusive)
    return calculateTaxDetail(taxData, amount, isExclusive)
  }

  const dataAmount = baseAmount(Number(qty), Number(unitPrice))
  let result = calculateTaxFromState(selectedTax, dataAmount)

  const taxSchemeInput = filterTaxSchemeEffectiveDate(date, getTaxScheme)

  const handleTaxAmtChange = event => {
    setTaxAmt(event)
  }

  useEffect(() => {
    if (selfBillStatus && itemEditData) {
      loadClassificationCode()
      itemRegister('einvoice_classification_code_id')
      setClassificationCodeID(menu?.obj?.einvoice_classification_code_id)
    }
  }, [])

  const initializeTaxDetailsInEditMode = selectTax => {
    if (menu?.obj?.ItemTaxInfo && Array.isArray(menu?.obj?.ItemTaxInfo)) {
      const formattedTaxDetails = menu.obj.ItemTaxInfo.map(item => ({
        taxId: item.taxId,
        taxCode: item.taxInfo?.code,
        schemeTypeCode: item.taxInfo?.schemeTypeCode,
        taxSchemeId: menu?.obj?.TaxSchemeID,
        taxSchemeDetailId: item.id,
        TaxRate: item.taxRate / 100,
        TaxAmount: item.taxAmt,
        SeqNo: item.id,
      }))
      menu.obj.ItemTaxInfo.forEach((taxDetail, index) => {
        itemRegister(`TaxAmtDetail[${index}]`)
        // Use absolute value for WHT to display as positive
        const displayTaxAmt =
          taxDetail.taxInfo?.schemeTypeCode === 'WHT'
            ? Math.abs(taxDetail.taxAmt)
            : taxDetail.taxAmt
        setValueItem(`TaxAmtDetail[${index}]`, displayTaxAmt)
      })
      setValueItem('taxDetailsCount', menu.obj.ItemTaxInfo.length)
      const totalTaxAmount = menu.obj.ItemTaxInfo.reduce((sum, item) => {
        // Use absolute value for WHT when calculating total display amount
        const amt =
          item.taxInfo?.schemeTypeCode === 'WHT'
            ? Math.abs(parseFloat(item.taxAmt) || 0)
            : parseFloat(item.taxAmt) || 0
        return sum + amt
      }, 0)
      setValueItem('TaxAmt', totalTaxAmount)
      setTaxAmt(totalTaxAmount)
      if (selectTax) {
        const currentAmount = baseAmount(
          Number(menu?.obj?.Quantity),
          Number(menu?.obj?.UnitPrice)
        )
        const calculatedResult = calculateTaxFromState(selectTax, currentAmount)
        if (calculatedResult) {
          calculatedResult.taxDetails = formattedTaxDetails
          calculatedResult.TaxAmount = totalTaxAmount
        }
      }
    } else if (
      menu?.obj?.TaxAmtDetails &&
      Array.isArray(menu?.obj?.TaxAmtDetails)
    ) {
      menu.obj.TaxAmtDetails.forEach((taxDetail, index) => {
        itemRegister(`TaxAmtDetail[${index}]`)
        // Use absolute value for WHT to display as positive
        const displayTaxAmt =
          taxDetail.schemeTypeCode === 'WHT'
            ? Math.abs(taxDetail.taxAmount)
            : taxDetail.taxAmount
        setValueItem(`TaxAmtDetail[${index}]`, displayTaxAmt)
      })
      setValueItem('taxDetailsCount', menu.obj.TaxAmtDetails.length)
      const totalTaxAmount = menu.obj.TaxAmtDetails.reduce((sum, item) => {
        // Use absolute value for WHT when calculating total display amount
        const amt =
          item.schemeTypeCode === 'WHT'
            ? Math.abs(parseFloat(item.taxAmount) || 0)
            : parseFloat(item.taxAmount) || 0
        return sum + amt
      }, 0)
      setValueItem('TaxAmt', totalTaxAmount)
      setTaxAmt(totalTaxAmount)
      if (selectTax) {
        const currentAmount = baseAmount(
          Number(menu?.obj?.Quantity),
          Number(menu?.obj?.UnitPrice)
        )
        calculateTaxFromState(selectTax, currentAmount)
      }
    } else if (selectTax) {
      const currentAmount = baseAmount(
        Number(menu?.obj?.Quantity),
        Number(menu?.obj?.UnitPrice)
      )
      const calculatedResult = calculateTaxFromState(selectTax, currentAmount)
      if (calculatedResult?.taxDetails) {
        updateTaxDetailsInForm(
          calculatedResult.taxDetails,
          calculatedResult.TaxAmount
        )
      }
    }
  }

  const updateTaxDetailsInForm = (taxDetails, taxAmount) => {
    if (!taxDetails || taxDetails.length === 0) return
    const prevTaxDetailsCount = itemWatch('taxDetailsCount') || 0

    let calculatedTotal = 0
    taxDetails.forEach((tax, index) => {
      itemRegister(`TaxAmtDetail[${index}]`)
      // Display absolute value for all taxes
      const displayValue = Math.abs(tax.TaxAmount)
      setValueItem(`TaxAmtDetail[${index}]`, displayValue)

      // Calculate total using absolute values for display
      calculatedTotal += displayValue
    })

    setValueItem('taxDetailsCount', taxDetails.length)
    if (prevTaxDetailsCount > taxDetails.length) {
      for (let i = taxDetails.length; i < prevTaxDetailsCount; i++) {
        setValueItem(`TaxAmtDetail[${i}]`, null)
      }
    }
    setValueItem('TaxAmt', calculatedTotal)
    setTaxAmt(calculatedTotal)
  }

  const handleTaxChange = event => {
    const newTaxId = event?.target?.value
    const newSelectedTax = taxSchemeInput.find(x => x?.id === newTaxId)
    setSelectedTax(newSelectedTax)
    const currentAmount = baseAmount(Number(qty), Number(unitPrice))
    const newResult = calculateTaxFromState(newSelectedTax, currentAmount)
    updateTaxDetailsInForm(newResult?.taxDetails, newResult?.TaxAmount)

    // Exempted Tax portion
    setShowExemptedFields(!!newSelectedTax?.isExemptedTaxScheme)

    if (newSelectedTax?.isExemptedTaxScheme === true) {
      fetchExemptedTaxCalc({
        variables: {
          TaxSchemeID: newTaxId,
          EffectiveDate: new Date(localData?.DocDate),
          BaseAmount: currentAmount,
        },
      })
    }
  }

  const handleAmtChange = event => {
    const newUnitPrice = parseFloat(event.value)
    setUnitPrice(newUnitPrice)
    setValueItem('UnitPrice', newUnitPrice)

    if (selectedTax) {
      const newAmount = baseAmount(Number(qty), newUnitPrice)
      const taxResult = calculateTaxFromState(selectedTax, newAmount)
      updateTaxDetailsInForm(taxResult?.taxDetails, taxResult?.TaxAmount)

      if (selectedTax?.isExemptedTaxScheme === true) {
        debounceExemptCalc(
          selectedTax?.id,
          new Date(localData?.DocDate),
          newAmount
        )
      }
    }
  }

  const baseAmt = selectedTax?.isExclusive
    ? amtNumStr(baseAmount(Number(qty), Number(unitPrice))).replace(
        /\B(?=(\d{3})+(?!\d))/g,
        ','
      )
    : amtNumStr(result?.ExcludeTaxAmount)

  const docAmt = selectedTax?.isExclusive
    ? getTotalAmtWithQty(qty, unitPrice, taxAmt)
    : baseAmount(Number(qty), Number(unitPrice))

  const handleQtyChange = event => {
    const newQty = event.value
    setQty(newQty)
    setValueItem('Quantity', newQty)
    if (selectedTax) {
      const newAmount = baseAmount(Number(newQty), Number(unitPrice))
      const taxResult = calculateTaxFromState(selectedTax, newAmount)
      updateTaxDetailsInForm(taxResult?.taxDetails, taxResult?.TaxAmount)

      if (selectedTax?.isExemptedTaxScheme === true) {
        debounceExemptCalc(
          selectedTax?.id,
          new Date(localData?.DocDate),
          newAmount
        )
      }
    }
  }

  useEffect(() => {
    if (
      !!getItemByCompany?.find(
        x => x?.ExpenseItemID === itemWatch('ExpenseItemID')
      )
    ) {
      setRefresh(false)
    }
  }, [getItemByCompany, menu])

  return (
    <>
      {HandlerLoading && <Loading />}
      {GPPolicyLoading && <Loading />}
      {GLCompanyLoading && <Loading />}
      {SalesOrderLoading && <Loading />}
      {ExpenseItemLoading && <Loading />}
      {DebtorAccountLoading && <Loading />}
      {ExemptedTaxCalcLoading && <Loading />}
      {TaxSchemeListingLoading && <Loading />}
      {DocDateValidationLoading && <Loading />}
      {ClassificationCodeLoading && <Loading />}
      <CommonDialog
        fullWidth={true}
        open={openItemDialog}
        onClose={() => setOpenItemDialog(false)}
        sections={{
          header: { title, rightText: detailMode === 'edit' ? 'Edit' : 'New' },
          body: () => (
            <>
              <div className="content-container" style={{ marginTop: '-20px' }}>
                {!refresh && (
                  <Controller
                    render={({ onChange, value }) => {
                      const selectedItem = getItemByCompany?.find(
                        x => x?.ExpenseItemID === itemWatch('ExpenseItemID')
                      )
                      return (
                        <PaginatedAutocomplete
                          // Important PaginatedAutocomplete props
                          // =====================================
                          searchVariable="searchValue" // Follow argument name in API (e.g. searchValue)
                          fetchMoreOptions={fetchExpenseItem}
                          setOptions={setOptions}
                          options={
                            getItemByCompany?.filter(x => x?.IsAP === true) ||
                            []
                          }
                          customItemColor={itemColor} // For AP and GP
                          setCustomItemColor={setItemColor} // For AP and GP
                          totalLength={totalLength}
                          setValue={setValueItem}
                          name="ExpenseItemID"
                          optionsLoading={ExpenseItemLoading}
                          // =====================================
                          getOptionLabel={option => `${option?.ItemName}`}
                          fullWidth
                          disabled={readOnly() === true ? true : false}
                          onChange={(value, newValue: any, reason) => {
                            setRefresh(false)
                            setValueItem(
                              'ExpenseItemID',
                              newValue?.ExpenseItemID
                            )
                            setMountDefVal(false)
                            if (reason !== 'clear') {
                              handleExpenseItemChange(newValue?.ExpenseItemID)
                            }
                            setValueItem('CostCentreID', '')
                            fetchDepartmentListingByItemID({
                              variables: {
                                CompanyID: companyID,
                                ExpenseItemID: newValue?.ExpenseItemID,
                              },
                            })

                            if (newValue?.IsInventory === true) {
                              setItemColor('darkblue')
                            } else setItemColor('')
                          }}
                          renderOption={(props, option) => {
                            return props?.IsInventory === true ? (
                              <span style={{ color: 'darkblue' }}>
                                {props?.ItemName}
                              </span>
                            ) : (
                              <span>{props?.ItemName}</span>
                            )
                          }}
                          value={selectedItem}
                          label="Item"
                          renderInput={(params: any) => {
                            return (
                              <div>
                                <TextField
                                  {...params}
                                  required
                                  label="Item"
                                  variant="standard"
                                  fullWidth
                                  name="ExpenseItemID"
                                  disabled={readOnly() === true ? true : false}
                                  helperText={
                                    itemErrors?.ExpenseItemID?.message
                                  }
                                  error={
                                    itemErrors?.ExpenseItemID ? true : false
                                  }
                                  InputProps={{
                                    ...params?.InputProps,
                                    style: { color: itemColor },
                                  }}
                                />
                              </div>
                            )
                          }}
                        />
                      )
                    }}
                    name="ExpenseItemID"
                    autoComplete="off"
                    control={itemControl}
                    multiline={true}
                    fullWidth
                    margin="dense"
                    ref={itemRegister}
                    required
                    disabled={readOnly() === true ? true : false}
                    defaultValue={menu?.obj?.ExpenseItemID}
                    helperText={itemErrors?.ExpenseItemID?.message}
                    error={itemErrors?.ExpenseItemID ? true : false}
                  />
                )}

                {/* Classification e-Invoice */}
                {!ClassificationCodeLoading &&
                  selfBillStatus &&
                  EInvoiceStarted && (
                    <Controller
                      render={({ value, onChange }) => {
                        const defVal = getClassificationCode?.find(
                          x =>
                            x?.id ===
                            (classificationCodeID ??
                              menu?.obj?.einvoice_classification_code_id ??
                              menu?.obj?.ClassificationCodeID)
                        )

                        return (
                          <Autocomplete
                            options={
                              getClassificationCode
                                ?.filter(x =>
                                  x?.description.includes('Self-billed')
                                )
                                ?.sort((a, b) => {
                                  return a?.classificationCode.localeCompare(
                                    b.classificationCode
                                  )
                                }) || []
                            }
                            getOptionLabel={option =>
                              `${option?.classificationCode} | ${option?.description}`
                            }
                            fullWidth
                            disabled={!selfBillStatus ? true : false}
                            onChange={(value, newValue: any) => {
                              setClassificationCodeID(newValue?.id)
                              itemRegister('einvoice_classification_code_id')
                              setValueItem(
                                'einvoice_classification_code_id',
                                newValue?.id
                              )
                            }}
                            renderOption={(props, option) => {
                              return (
                                <>
                                  <div>
                                    <div>
                                      <span className="xsTitle">
                                        {props?.classificationCode}
                                      </span>
                                    </div>
                                    <div className="desc">
                                      {props?.description}
                                    </div>
                                  </div>
                                </>
                              )
                            }}
                            defaultValue={defVal}
                            renderInput={(params: any) => {
                              return (
                                <div>
                                  <TextField
                                    {...params}
                                    required
                                    label="Classification Code"
                                    variant="standard"
                                    fullWidth
                                    name="einvoice_classification_code_id"
                                    disabled={!selfBillStatus ? true : false}
                                    helperText={
                                      (itemWatch(
                                        'einvoice_classification_code_id'
                                      ) === '' ||
                                        itemWatch(
                                          'einvoice_classification_code_id'
                                        ) === undefined) &&
                                      itemErrors
                                        ?.einvoice_classification_code_id
                                        ?.message
                                    }
                                    error={
                                      (itemWatch(
                                        'einvoice_classification_code_id'
                                      ) === '' ||
                                        itemWatch(
                                          'einvoice_classification_code_id'
                                        ) === undefined) &&
                                      itemErrors?.einvoice_classification_code_id
                                        ? true
                                        : false
                                    }
                                    defaultValue={
                                      menu
                                        ? menu?.obj
                                            ?.einvoice_classification_code_id
                                        : null
                                    }
                                  />
                                </div>
                              )
                            }}
                          />
                        )
                      }}
                      name="einvoice_classification_code_id"
                      autoComplete="off"
                      control={itemControl}
                      multiline={true}
                      fullWidth
                      margin="dense"
                      ref={itemRegister}
                      required
                      defaultValue={
                        menu
                          ? (menu?.obj?.einvoice_classification_code_id ??
                            menu?.obj?.ClassificationCodeID ??
                            classificationCodeID)
                          : null
                      }
                      disabled={!selfBillStatus ? true : false}
                    />
                  )}

                {!HandlerLoading && (
                  <Controller
                    render={({ value, onChange }) => {
                      const ccOptions = getDepartmentListingByItemID
                      const selectedCC = ccOptions?.find(
                        x => x?.CostCentreID === menu?.obj?.CostCentreID
                      )
                      const defVal =
                        getDepartmentListingByItemID?.find(
                          x => x?.CostCentreID === value
                        ) ?? null

                      return (
                        <Autocomplete
                          options={
                            ccOptions?.sort((a, b) => {
                              return a.Code.localeCompare(b.Code)
                            }) || []
                          }
                          getOptionLabel={option =>
                            `${option?.MasterCode} | ${option?.Name}`
                          }
                          value={
                            !!disableDeptController
                              ? getDepartmentListingByItemID?.find(
                                  cc => cc?.IsDefault === true
                                )
                              : defVal
                          }
                          fullWidth
                          disableClearable={disableDeptController}
                          disabled={
                            readOnly() === true ? true : disableDeptController
                          }
                          onChange={(value, newValue: any, reason) => {
                            itemRegister('CostCentreID')
                            setValueItem('CostCentreID', newValue?.CostCentreID)
                            if (reason === 'clear') {
                              setValueItem('CostCentreID', '')
                            }
                          }}
                          renderOption={(props, option) => {
                            return (
                              <div>
                                <div>
                                  <span className="xsTitle">
                                    {props?.MasterCode}
                                  </span>
                                </div>
                                <div className="desc">{props?.Name}</div>
                              </div>
                            )
                          }}
                          renderInput={(params: any) => {
                            return (
                              <div>
                                <TextField
                                  {...params}
                                  required
                                  label="Department"
                                  variant="standard"
                                  fullWidth
                                  name="CostCentreID"
                                  disabled={
                                    readOnly() === true
                                      ? true
                                      : disableDeptController
                                  }
                                  helperText={
                                    (itemWatch('CostCentreID') === '' ||
                                      itemWatch('CostCentreID') === undefined ||
                                      itemWatch('CostCentreID') === null) &&
                                    itemErrors?.CostCentreID?.message
                                  }
                                  error={
                                    (itemWatch('CostCentreID') === '' ||
                                      itemWatch('CostCentreID') === undefined ||
                                      itemWatch('CostCentreID') === null) &&
                                    itemErrors?.CostCentreID
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            )
                          }}
                        />
                      )
                    }}
                    name="CostCentreID"
                    autoComplete="off"
                    control={itemControl}
                    multiline={true}
                    fullWidth
                    margin="dense"
                    ref={itemRegister()}
                    required
                    disabled={
                      readOnly() === true ? true : disableDeptController
                    }
                    helperText={
                      (itemWatch('CostCentreID') === '' ||
                        itemWatch('CostCentreID') === undefined ||
                        itemWatch('CostCentreID') === null) &&
                      itemErrors?.CostCentreID?.message
                    }
                    error={
                      (itemWatch('CostCentreID') === '' ||
                        itemWatch('CostCentreID') === undefined ||
                        itemWatch('CostCentreID') === null) &&
                      itemErrors?.CostCentreID
                        ? true
                        : false
                    }
                    defaultValue={
                      menu?.obj?.CostCentreID ? menu?.obj?.CostCentreID : ''
                    }
                  />
                )}

                {(docType === 'creditor-credit-note' ||
                  docType === 'creditor-debit-note' ||
                  docType === 'ap-invoice') &&
                  !DebtorAccountLoading && (
                    <Controller
                      render={({ value, onChange }) => {
                        const defVal = getDebtorAccount?.filter(
                          coa =>
                            coa?.DebtorAccountID === menu?.obj?.DebtorAccountID
                        )[0]

                        return (
                          <Autocomplete
                            ref={itemRegister}
                            options={
                              getDebtorAccount?.sort((a, b) => {
                                return a?.DebtorName?.localeCompare(
                                  b?.DebtorName
                                )
                              }) || []
                            }
                            getOptionLabel={option => {
                              return `${option?.DebtorName}`
                            }}
                            fullWidth
                            onChange={(value, newValue: any) => {
                              setValueItem(
                                'DebtorAccountID',
                                newValue?.DebtorAccountID
                              )
                              fetchSalesOrder({
                                variables: {
                                  DebtorAccountID:
                                    newValue?.DebtorAccountID ?? null,
                                },
                              })
                            }}
                            defaultValue={defVal}
                            // disabled={mode === 'approve-reject'}
                            renderOption={(props, option) => {
                              return (
                                <div>
                                  <div>
                                    <span className="xsTitle">
                                      {props?.DebtorName}
                                    </span>
                                  </div>
                                </div>
                              )
                            }}
                            renderInput={(params: any) => {
                              return (
                                <div>
                                  <TextField
                                    {...params}
                                    // helperText={errors?.DebtorAccountID?.message}
                                    // error={errors?.DebtorAccountID ? true : false}
                                    label="Customer Name"
                                    style={{
                                      width: '100%',
                                    }}
                                    margin="normal"
                                  />
                                </div>
                              )
                            }}
                          />
                        )
                      }}
                      label="Customer Name"
                      name="DebtorAccountID"
                      autoComplete="off"
                      control={itemControl}
                      multiline={true}
                      fullWidth
                      margin="normal"
                      ref={itemRegister}
                      // helperText={errors?.DebtorAccountID?.message}
                      // error={errors?.DebtorAccountID ? true : false}
                      defaultValue={menu?.obj?.DebtorAccountID || null}
                    />
                  )}

                {(docType === 'creditor-credit-note' ||
                  docType === 'creditor-debit-note' ||
                  docType === 'ap-invoice') && (
                  // !SalesOrderLoading &&
                  <Controller
                    render={({ value, onChange }) => {
                      const defVal = getSalesOrderByDebtor?.find(
                        coa => coa?.id === (value || menu?.obj?.SalesOrderID)
                      )

                      return (
                        <Autocomplete
                          options={getSalesOrderByDebtor || []}
                          getOptionLabel={option => {
                            const revised = option?.revisedOrderSum
                            const fallback = option?.orderSum
                            const amount = revised
                              ? amtStr(revised)
                              : amtStr(fallback)
                            return `${option?.title || 'N/A'} | ${amount ||
                              'N/A'}`
                          }}
                          value={defVal || null}
                          fullWidth
                          onChange={(event, newValue: any) => {
                            onChange(newValue?.id || null)
                            setValueItem('SalesOrderID', newValue?.id || null)
                          }}
                          renderOption={(props, option) => (
                            <Fragment>
                              <ListItemText
                                primary={
                                  <Grid container>
                                    <Grid
                                      item
                                      xs={8}
                                      component="span"
                                      className="xsTitle"
                                    >
                                      {props?.title || 'N/A'}
                                    </Grid>
                                    <Grid
                                      item
                                      xs={4}
                                      component="span"
                                      className="xsTitle right-text highlight-text"
                                    >
                                      {amtStr(
                                        props?.revisedOrderSum ??
                                          props?.orderSum
                                      )}
                                    </Grid>
                                  </Grid>
                                }
                              />
                            </Fragment>
                          )}
                          renderInput={(params: any) => (
                            <div>
                              <TextField
                                {...params}
                                label="Sales Order"
                                style={{ width: '100%' }}
                                margin="normal"
                              />
                            </div>
                          )}
                        />
                      )
                    }}
                    name="SalesOrderID"
                    control={itemControl}
                    defaultValue={menu?.obj?.SalesOrderID || null}
                  />
                )}

                <Grid
                  item
                  xs={6}
                  style={{
                    marginBottom: '5px',
                    paddingRight: '10px',
                    marginTop: '11px',
                  }}
                >
                  <Controller
                    as={<NumberFormat allowNegative={false} />}
                    required
                    value={qty}
                    margin="dense"
                    ref={itemRegister}
                    name="Quantity"
                    label="Qty"
                    decimalScale={4}
                    control={itemControl}
                    autoComplete="off"
                    fixedDecimalScale
                    thousandSeparator
                    id="standard-basic"
                    customInput={TextField}
                    onValueChange={e => {
                      handleQtyChange(e)
                    }}
                    helperText={itemErrors?.Quantity?.message}
                    error={itemErrors?.Quantity ? true : false}
                    disabled={readOnly() === true ? true : false}
                    defaultValue={menu?.obj ? menu?.obj?.Quantity : 0}
                  />
                </Grid>

                <Grid item xs={6} style={{ marginBottom: '5px' }}>
                  {!uomExcLoading && (
                    <Controller
                      render={({ value, onChange }) => {
                        const defVal = getUOMExchangeList?.filter(
                          x => x?.uomid === uomID
                        )[0]

                        return (
                          <Autocomplete
                            options={getUOMExchangeList || []}
                            getOptionLabel={option => `${option?.uomcode}`}
                            filterOptions={createFilterOptions({
                              stringify: option =>
                                option.uomcode + option.uomname,
                            })}
                            fullWidth
                            onChange={(value, newValue: any) => {
                              setUomID(newValue?.uomid)
                              // onChange(newValue?.uomid)
                              itemRegister('UOMID')
                            }}
                            disabled={readOnly() === true ? true : false}
                            renderOption={(props, option) => {
                              return (
                                <div>
                                  <div>
                                    <span className="xsTitle">
                                      {props?.uomcode}
                                    </span>
                                  </div>
                                  <div className="desc">{props?.uomname}</div>
                                </div>
                              )
                            }}
                            defaultValue={defVal}
                            renderInput={(params: any) => {
                              return (
                                <div>
                                  <TextField
                                    {...params}
                                    label="UOM"
                                    style={{ width: '100%' }}
                                    margin="normal"
                                    required
                                    helperText={itemErrors?.UOMID?.message}
                                    error={itemErrors?.UOMID ? true : false}
                                  />
                                </div>
                              )
                            }}
                          />
                        )
                      }}
                      label="UOM"
                      name="UOMID"
                      autoComplete="off"
                      control={itemControl}
                      multiline={true}
                      fullWidth
                      margin="normal"
                      ref={itemRegister}
                      // helperText={errors?.UOMID?.message}
                      // error={errors?.UOMID ? true : false}
                      defaultValue={menu?.obj?.UOMID}
                      required
                    />
                  )}
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{ marginBottom: '5px', paddingRight: '10px' }}
                >
                  <Controller
                    as={
                      <NumberFormat
                        allowNegative={false}
                        value={unitPrice}
                        required
                        customInput={TextField}
                        thousandSeparator
                        decimalScale={4}
                        fixedDecimalScale
                        isNumericString
                        label="Unit Price"
                        disabled={
                          readOnly() === true &&
                          !getGeneralPurchasePolicy[0]?.GRNStatus
                            ? true
                            : false
                        }
                        onValueChange={e => {
                          setUnitPrice(e?.floatValue)
                          setValueItem('UnitPrice', e?.floatValue)
                          handleAmtChange(e)
                        }}
                      />
                    }
                    onChange={(value, newValue: any) => {
                      handleAmtChange(newValue)
                    }}
                    name="UnitPrice"
                    control={itemControl}
                    margin="dense"
                    required
                    helperText={itemErrors?.UnitPrice?.message}
                    error={itemErrors?.UnitPrice ? true : false}
                    ref={itemRegister}
                    defaultValue={menu?.obj?.UnitPrice ?? 0}
                  />
                </Grid>
                <Grid item xs={6} style={{ marginBottom: '5px' }}>
                  <TextField
                    name={'Amount'}
                    label="Base Amt"
                    value={amtStr(docAmt - taxAmt)}
                    margin="dense"
                    ref={itemRegister}
                    style={{ color: 'white' }}
                    disabled
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginBottom: '5px',
                    paddingRight: '10px',
                  }}
                >
                  <Controller
                    as={
                      <TextField
                        margin="dense"
                        label="Tax Scheme"
                        required
                        SelectProps={{
                          renderValue: () =>
                            `${selectedTax?.name} | ${
                              selectedTax?.description
                            } ${selectedTax?.isExclusive ? `(E)` : `(I)`}`,
                          onChange: event => {
                            handleTaxChange(event)
                            setValueItem(
                              'TaxSchemeID',
                              event?.target?.value.toString()
                            )
                            clearErrorsItem('TaxSchemeID')
                          },
                        }}
                        select
                      >
                        {taxSchemeInput?.map((tax, index) => (
                          <MenuItem id="tax-select" key={index} value={tax?.id}>
                            {
                              <div className="content-wrap full">
                                <div>
                                  <span className="xsTitle">{tax?.name}</span>
                                </div>
                                <div className="desc">
                                  {tax?.description}{' '}
                                  {tax?.isExclusive ? `(E)` : `(I)`}
                                </div>
                              </div>
                            }
                          </MenuItem>
                        ))}
                      </TextField>
                    }
                    select
                    name="TaxSchemeID"
                    autoComplete="off"
                    control={itemControl}
                    helperText={itemErrors?.TaxSchemeID?.message}
                    error={itemErrors?.TaxSchemeID ? true : false}
                    defaultValue={menu?.obj?.TaxSchemeID || ''}
                    ref={itemRegister()}
                  />
                </Grid>

                {result.taxDetails.length > 0 && (
                  <Grid item xs={12}>
                    <Paper
                      elevation={1}
                      style={{
                        padding: '1px 7px',
                        borderRadius: '2px',
                        backgroundColor: '#fff9f2',
                      }}
                    >
                      {result.taxDetails.map((tax, index) => {
                        return (
                          <Grid
                            container
                            key={index}
                            spacing={1}
                            alignItems="center"
                          >
                            <Grid item xs={4}>
                              <Typography
                                variant="body2"
                                style={{
                                  fontSize: '0.63rem',
                                  fontWeight: 500,
                                  lineHeight: '24px',
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                {tax?.taxCode || `Tax ${index + 1}`}
                              </Typography>
                            </Grid>

                            <Grid item xs={3}>
                              <Typography
                                variant="body2"
                                style={{
                                  fontSize: '0.63rem',
                                  fontWeight: 500,
                                  lineHeight: '24px',
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                {typeof tax?.TaxRate === 'number'
                                  ? `${(tax.TaxRate * 100).toFixed(2)}%`
                                  : `N/A`}
                              </Typography>
                            </Grid>

                            <Grid item xs={5}>
                              <Controller
                                disabled={!!showExemptedFields}
                                name={`TaxAmtDetail[${index}]`}
                                control={itemControl}
                                defaultValue={tax.TaxAmount}
                                render={({ onChange, value }) => (
                                  <NumberFormat
                                    disabled={!!showExemptedFields}
                                    customInput={TextField}
                                    fullWidth
                                    className="disabled-input"
                                    thousandSeparator
                                    decimalScale={2}
                                    fixedDecimalScale
                                    style={{
                                      marginTop: '10px',
                                      fontSize: '0.63rem',
                                    }}
                                    allowNegative={false}
                                    variant="outlined"
                                    size="small"
                                    value={
                                      itemWatch(`TaxAmtDetail[${index}]`) ??
                                      tax.TaxAmount
                                    }
                                    onValueChange={({ floatValue }) => {
                                      onChange(floatValue)

                                      const allTaxDetails =
                                        itemWatch('TaxAmtDetail') || []

                                      allTaxDetails[index] = floatValue ?? 0

                                      const total = allTaxDetails.reduce(
                                        (acc, val, idx) => {
                                          const amount = parseFloat(val) || 0
                                          // Sum all amounts as positive for display
                                          return acc + amount
                                        },
                                        0
                                      )

                                      setValueItem('TaxAmt', total)
                                    }}
                                    InputProps={{
                                      style: {
                                        fontSize: '0.63rem',
                                        height: '23px',
                                        padding: '0 4px',
                                        backgroundColor: '#ffffff',
                                      },
                                    }}
                                    InputLabelProps={{
                                      style: { display: 'none' },
                                    }}
                                  />
                                )}
                              />
                            </Grid>
                          </Grid>
                        )
                      })}
                    </Paper>
                  </Grid>
                )}
                <Grid item xs={12} style={{ height: '16px' }} />
                <Grid item xs={6}>
                  <Controller
                    as={<NumberFormat allowNegative={false} />}
                    thousandSeparator
                    customInput={TextField}
                    ref={itemRegister()}
                    control={itemControl}
                    margin="dense"
                    name="TaxAmt"
                    label="Tax Amount"
                    className="left"
                    onValueChange={e => {
                      handleTaxAmtChange(e?.value)
                      setTaxAmt(e?.value)
                    }}
                    // value={taxAmt}
                    defaultValue={menu?.obj?.TaxAmt ?? taxAmt ?? 0}
                    decimalScale={2}
                    fixedDecimalScale
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Controller
                    render={({ value, onChange }) => {
                      value = { docAmt }
                      return (
                        <TextField
                          margin="dense"
                          label="Doc Amount"
                          value={
                            selectedTax?.isExclusive
                              ? amtStr(String(docAmt))
                              : amtStr(
                                  baseAmount(Number(qty), Number(unitPrice))
                                )
                          }
                          InputProps={{
                            readOnly: true,
                            disableUnderline: true,
                          }}
                          className="right"
                          disabled
                        />
                      )
                    }}
                    disabled
                    margin="dense"
                    defaultValue={docAmt}
                    name="DocAmt"
                    ref={itemRegister()}
                    control={itemControl}
                  />
                </Grid>

                <ItemVoiceTextField
                  mounted={true}
                  required
                  label="Remark"
                  name="Remark"
                  value={itemVoiceRemark}
                  setValue={setValueItem}
                  record={itemRecord}
                  setRecord={setItemRecord}
                  control={itemControl}
                  controllerProps={{
                    error: itemErrors?.Remark ? true : false,
                    defaultValue: menu?.obj?.Remark,
                    helperText: itemErrors?.Remark?.message,
                    ref: itemRegister,
                    autoComplete: 'off',
                  }}
                />

                {showExemptedFields && (
                  <>
                    <ItemVoiceTextField
                      mounted={true}
                      required
                      label="Tax Exemption Reason"
                      name="TaxExemptionReason"
                      value={exemptionVoiceReason}
                      setValue={setValueItem}
                      record={exemptionRecord}
                      setRecord={setExemptionRecord}
                      control={itemControl}
                      controllerProps={{
                        error: itemErrors?.TaxExemptionReason ? true : false,
                        defaultValue: menu?.obj?.TaxExemptionReason,
                        helperText: itemErrors?.TaxExemptionReason?.message,
                        ref: itemRegister,
                        autoComplete: 'off',
                      }}
                    />
                    <TextField
                      margin="dense"
                      label="Exemptible Tax Amount"
                      value={amtStr(taxExemptionData?.TaxExemptionAmount)}
                      InputProps={{
                        readOnly: true,
                        disableUnderline: true,
                        endAdornment: (
                          <>
                            {awaitCalc ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                          </>
                        ),
                      }}
                      className="left"
                      disabled
                    />
                    {/* <TextField
                      margin="dense"
                      label="Exemptible Tax Rate"
                      value={`${amtStr(taxExemptionData?.TaxExemptionRate)}%`}
                      InputProps={{
                        readOnly: true,
                        disableUnderline: true,
                        endAdornment: (
                          <>
                            {awaitCalc ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                          </>
                        ),
                      }}
                      className="right"
                      disabled
                    /> */}
                  </>
                )}
              </div>

              <ErrorDialog
                errorDia={errorDia}
                setErrorDia={setErrorDia}
                errorMsg={errMsg}
                errorHeaderMsg={'Error!'}
              />
            </>
          ),
          footer: {
            actions:
              detailMode === 'add'
                ? [
                    closeFooterOption,
                    {
                      displayText: 'Confirm & New',
                      props: {
                        onClick: () => {
                          handleItemSubmit(data =>
                            onSubmit(
                              data,
                              docAmt,
                              qty,
                              unitPrice,
                              baseAmt,
                              menu?.index,
                              true
                            )
                          )()
                        },
                        variant: 'contained',
                        color: 'primary',
                        disabled: !!ExpenseItemLoading || !!awaitCalc,
                      },
                    },
                    {
                      displayText: 'Confirm',
                      props: {
                        onClick: () => {
                          handleItemSubmit(data =>
                            onSubmit(
                              data,
                              docAmt,
                              qty,
                              unitPrice,
                              baseAmt,
                              menu?.index,
                              false
                            )
                          )()
                        },
                        variant: 'contained',
                        color: 'primary',
                        disabled: !!ExpenseItemLoading || !!awaitCalc,
                      },
                    },
                  ]
                : [
                    closeFooterOption,
                    {
                      displayText: 'Confirm',
                      props: {
                        onClick: () => {
                          handleItemSubmit(data =>
                            onSubmit(
                              data,
                              docAmt,
                              qty,
                              unitPrice,
                              baseAmt,
                              menu?.index,
                              false
                            )
                          )()
                        },
                        variant: 'contained',
                        color: 'primary',
                        disabled: !!ExpenseItemLoading || !!awaitCalc,
                      },
                    },
                  ],
          },
        }}
      />
    </>
  )
}
